import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AbilitiesService from 'ember-can/services/abilities';

export default class MeetingAbility extends Ability {
  @service declare abilities: AbilitiesService;

  get canVisit(): boolean {
    return this.abilities.can('visit visitors') || this.abilities.can('trial visitors');
  }
}
